import { Link } from "react-router-dom";

export default function Returns() {
  return (
    <div className="max-w-[1000px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl mb-16">
        <div className="ie-overline text-brand-accent mb-4">
          Care
        </div>

        <h1 className="font-serif text-5xl md:text-6xl tracking-tight">
          Returns & Exchanges
        </h1>

        <p className="text-text-secondary text-sm leading-7 mt-6">
          Our return process is designed to keep things simple and clear.
        </p>
      </div>

      <div className="space-y-12 text-sm text-text-secondary leading-7">
        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Eligibility
          </h2>
          <p>
            Items must be unused, unworn, unwashed and returned in their
            original condition with original tags and packaging intact.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Return Window
          </h2>
          <p>
            Return requests must be submitted within the return period
            specified for your order. The applicable return window and
            conditions should be confirmed before submitting a request.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Non-Returnable Items
          </h2>
          <p>
            Items that have been worn, washed, altered, damaged after delivery
            or returned without their original tags may not qualify for a
            return.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            How to Request a Return
          </h2>
          <p>
            Contact our care team with your order number and the reason for
            your return. Our team will provide the next steps after reviewing
            your request.
          </p>

          <Link to="/contact" className="ie-btn-primary inline-flex mt-5">
            Contact Care
          </Link>
        </section>

        <section>
          <h2 className="font-serif text-2xl text-foreground mb-4">
            Refunds
          </h2>
          <p>
            Approved refunds are processed through the applicable payment
            method and may take additional time to appear depending on the
            payment provider or bank.
          </p>
        </section>
      </div>
    </div>
  );
}